import {Injectable} from '@angular/core';
import {ScriptLoad, ScriptStatus} from '../interfaces/zoid-app-script';
import {environment} from "../../../environments/environment";
import {ZoidApp} from "../interfaces/zoid-app";
import {LoggerService} from "./logger.service";
import {LogEvent} from "../enums/log-event";

@Injectable({ providedIn: 'root' })
export class DynamicScriptLoaderService {

  private scripts: Record<string, { loaded: boolean }> = {};

  constructor(private logger: LoggerService) {
  }

  getAppScriptId(appName: string) {
    return `zoid-script-${appName}`;
  }

  loadScript(app: ZoidApp): Promise<ScriptLoad> {
    const src = `${environment.externalUrls.sdk}?url=${app.url}&componentName=%22${app.name}%22`;
    return new Promise((resolve) => {
      if (!this.scripts[app.name] || !this.scripts[app.name].loaded) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = this.getAppScriptId(app.name);

        script.onload = () => {
          this.scripts[app.name] = { loaded: true };
          resolve({ scriptName: app.name, loaded: true, status: ScriptStatus.LOADED });
        };

        window.onerror = (event) => {
          if (event === 'Script error.') {
            return;
          }
          throw event;
        }

        script.onerror = () => resolve({ scriptName: app.name, loaded: false, status: ScriptStatus.ERROR });

        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve({ scriptName: app.name, loaded: true, status: ScriptStatus.ALREADY_LOADED });
      }
    });
  }

  unloadScript(appName: string) {
    if(!this.scripts[appName]) {
      this.logger.warn(LogEvent.LIVECHAT_UNLOAD_APP_WARNING, {message: `Trying to unload an app that is not loaded: ${appName}`})
      return;
    }

    document.getElementById(this.getAppScriptId(appName))?.remove();
    delete this.scripts[appName];
  }
}
